module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedThin.deca385.woff2";